/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendBusinessAngelDto } from '../../models/backend-business-angel-dto';
import { BackendPatchedBusinessAngelRequestDto } from '../../models/backend-patched-business-angel-request-dto';

export interface VentureFundsBusinessAngelsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedBusinessAngelRequestDto;
}

export function ventureFundsBusinessAngelsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendBusinessAngelDto>;
    }),
  );
}

ventureFundsBusinessAngelsPartialUpdate.PATH = '/api/venture_funds/business-angels/{id}/';
